module.exports = __webpack_public_path__ + "img/temp.a7750f24.png";